import { Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit, ViewChild, AfterContentChecked, HostListener } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Subscription } from 'rxjs';
import { AuthenticationService } from './../../core/services/auth.service';
import { SpinnerService } from '../../core/services/spinner.service';
import { NavigationEnd, Router } from '@angular/router';
import { IBreadCrumb } from '../interfaces/breadcrumb.interface';
import { MatSidenav } from '@angular/material/sidenav';
import { TranslateService } from '@ngx-translate/core';
import { UserIdleService } from 'angular-user-idle';
import { MatMenuTrigger } from '@angular/material/menu';
import { AllRoles, UserRoles } from 'src/app/core/enumurations/user-roles.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/core/services/user.service';
import { EditPasswordComponent } from '../modals/edit-password/edit-password.component';
import { LayoutService } from '../services/layout.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {

    @ViewChild('snav', { static: true }) sidenav: MatSidenav;

    private _mobileQueryListener: () => void;
    mobileQuery: MediaQueryList;
    showSpinner: boolean;
    userName: string;
    isAdmin: boolean;
    imgSrc;
    private autoLogoutSubscription: Subscription;
    toggledInNotification;
    notificationNumber;

    public breadcrumbs: IBreadCrumb[];

    drawerCanToggle = true;

    activeRoute: any = {
        users: false,
        settings: false,
        settingsTypeApp: false,
        settingsCours: false,
        settingsCentres: false,
        settingsAnneesScolaires: false,
        groups: false,
        calendars: false,
        apprenants: false
    }
    language;
    notificationsList = [];
    settingsMenu = false;
    isSettingsMenuEntered = false;
    isSettingsIconhovered = false;

    @ViewChild('triggerSettings', { read: MatMenuTrigger }) protected settingsMenuBtn: MatMenuTrigger;
    contextMenu: MatMenuTrigger;
    contextMenuPosition = { x: '0px', y: '0px' };
    timedOutCloser;
    settingSubMenu = [];
    redirectUrl;
    lastActivityTime;
    @HostListener('document:mousemove', ['$event'])
    @HostListener('document:keypress', ['$event'])
    @HostListener('document:keydown', ['$event'])
    @HostListener('document:wheel', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        localStorage.setItem('lastActivityTime', new Date().toISOString());
    }

    myObserver = null;
    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private media: MediaMatcher,
        public spinnerService: SpinnerService,
        private authService: AuthenticationService,
        private userService: UserService,
        private router: Router,
        private translate: TranslateService,
        private userIdle: UserIdleService,
        private modalService: NgbModal,
        public dialog: MatDialog,
        private layoutService: LayoutService) {

        this.mobileQuery = this.media.matchMedia('(max-width: 1250px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        // tslint:disable-next-line: deprecation
        this.mobileQuery.addListener(this._mobileQueryListener);

        this.language = localStorage.getItem('current-language') ? localStorage.getItem('current-language') : 'ar';
        this.translate.use(this.language);
        
        
        this.myObserver = router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.defineActiveMenuIconFromActiveRoute();
                this.manageStoredFilters();
                this.redirectUrl = this.router.url;
                this.modalService.dismissAll();
                this.dialog.closeAll();
                const user = this.authService.getCurrentUser();
                if(user){
                    this.getNotifications();
                }
                
            }
        });
        this.buildSubMenus();
        setInterval(()=>{
            this.getNotifications();},15000)
    }

    toggleNotification(event,index){
        event.stopPropagation();
        if(this.toggledInNotification == index)
            this.toggledInNotification = undefined;
        else
            this.toggledInNotification = index;
    }

    isToggledIn(index){
        return this.toggledInNotification == index;
    }

    ngOnInit(): void {
        const user = this.authService.getCurrentUser();
        this.imgSrc = "data:image/jpeg;base64," + this.authService.defaultImg;
        this.userService.getPhotoProfil(user["userKey"]).subscribe(
            (res) => {
                var reader = new FileReader();
                reader.readAsDataURL(res);
                reader.onload = () => {
                    var base64data = reader.result;
                    if (base64data && res["type"] != "application/json") {
                        this.imgSrc = base64data;
                    }
                    else if (user.civility && user.civility.toUpperCase() == "MONSIEUR") {
                        this.imgSrc = "assets/imgs/default-user.jpg";
                    }
                    else if (user.civility && user.civility.toUpperCase() == "MADAME") {
                        this.imgSrc = "assets/imgs/default-user2.jpg";
                    }
                };
            },
            () => {
                if (user.civility && user.civility.toUpperCase() == "MONSIEUR") {
                    this.imgSrc = "assets/imgs/default-user.jpg";
                }
                else {
                    this.imgSrc = "assets/imgs/default-user2.jpg";
                }
            }
        );
        this.isAdmin = user.isAdmin;
        this.userName = user.firstName + " " + user.lastName;

        // Auto log-out subscription
        const timer = TimerObservable.create(2000, 5000);
        this.autoLogoutSubscription = timer.subscribe(t => {
            this.checkIfUserConnected();
        });

        this.checkUserInactivity();
        this.getNotifsListener();
    }

    getNotifsListener() {
        this.spinnerService.notifications.subscribe((result) => {

            if (result) {
                this.getNotifications();
            }
        })
    }

    goToEditProfile() {
        this.router.navigate(["home/profile/edit"])
    }

    openEditPasswordDialog() {
        this.dialog.open(EditPasswordComponent, {
            width: '500px',
            disableClose: true
        });
    }

    checkIfUserConnected() {
        const user = this.authService.getCurrentUser();
        if (user && user.expiration) {
            if (!(new Date() < new Date(user.expiration))) {
                this.authService.logout(true);
                this.router.navigate(['auth/login']);
            }
        }
        else {
            this.authService.logout(true);
            this.router.navigate(['auth/login']);
        }
    }

    ngAfterViewInit() {
        this.changeDetectorRef.detectChanges();
    }

    ngAfterContentChecked(): void {

    }

    buildSubMenus() {
        this.settingSubMenu = [
            { canShow: this.authService.hasAnyRole(AllRoles.filter(role => UserRoles.ENSEIGNANT != role)), title: "APPRENTISSAGE.TYPES_APPRENTISSAGES_MENU_TITLE", routerLink: ['/home/settings/typesApprentissages'], isActiveRoute: this.activeRoute.settingsTypeApp },
            { canShow: this.authService.hasAnyRole(AllRoles.filter(role => [/*UserRoles.COORDINATEUR_REGIONAL,*/ UserRoles.ENSEIGNANT].indexOf(role) == -1)), title: "COURS.LIST_TITLE_MENU_TITLE", routerLink: ['/home/settings/cours'], isActiveRoute: this.activeRoute.settingsCours },
            { canShow: this.authService.hasAnyRole([UserRoles.ADMIN,  UserRoles.DIRECTION_GENERALE, UserRoles.COORDINATEUR_REGIONAL]), title: "CENTRE.MENU_TITLE", routerLink: ['/home/settings/centres'], isActiveRoute: this.activeRoute.settingsCentres },
            { canShow: this.authService.hasAnyRole([UserRoles.ADMIN, UserRoles.DIRECTION_EDUCATION_ET_GOUVERNANCE,UserRoles.DIRECTION_GENERALE, UserRoles.COORDINATEUR_REGIONAL]), title: "ANNEE_SCOLAIRE.TITLE", routerLink: ['/home/settings/anneesScolaires'], isActiveRoute: this.activeRoute.settingsAnneesScolaires }
        ]
    }

    canShowUserManagement() {
        return this.authService.hasAnyRole(AllRoles.filter(role => role !== UserRoles.ENSEIGNANT))
    }

    canShowGroupManagement() {
        return this.authService.hasAnyRole([UserRoles.COORDINATEUR_REGIONAL, UserRoles.ENSEIGNANT, UserRoles.ADMIN,
        UserRoles.DIRECTION_EDUCATION_ET_GOUVERNANCE, UserRoles.DIRECTION_GENERALE])
    }

    canShowApprenantManagement() {
        return this.authService.hasAnyRole([UserRoles.ENSEIGNANT, UserRoles.COORDINATEUR_REGIONAL, UserRoles.ADMIN, 
        UserRoles.DIRECTION_EDUCATION_ET_GOUVERNANCE, UserRoles.DIRECTION_GENERALE])
    }

    getSubMenusLengths() {
        return {
            settings: this.settingSubMenu.filter(el => el.canShow).length
        }
    }

    checkUserInactivity() {
        const rememberMe = localStorage.getItem('rememberMe');
        if (!rememberMe || rememberMe == "false") {
            this.userIdle.stopWatching();
            this.userIdle.resetTimer();
            this.userIdle.setConfigValues({ idle: 300, timeout: 32, ping: 30 });
            this.userIdle.startWatching();
            this.userIdle.onTimerStart().subscribe(
                (count: any) => {
                }
            );
            this.userIdle.ping$.subscribe(() => {
                if (localStorage.getItem('lastActivityTime') != this.lastActivityTime) {
                    this.lastActivityTime = localStorage.getItem('lastActivityTime');
                    this.userIdle.stopWatching();
                    this.userIdle.resetTimer();
                    this.userIdle.setConfigValues({ idle: 300, timeout: 32, ping: 30 });
                    this.userIdle.startWatching();
                }
            });
            // Start watch when time is up.
            this.userIdle.onTimeout().subscribe(() => {
                this.dialog.closeAll();
                this.modalService.dismissAll();
                this.userIdle.stopWatching();
                this.mobileQuery.removeListener(this._mobileQueryListener);
                this.autoLogoutSubscription.unsubscribe();
                if (!this.authService.alreadyLoggedOut) {
                    this.authService.logout(true);
                    this.router.navigate(['auth/login'], { queryParams: { redirectUrl: this.redirectUrl } });
                }

            });
        }

    }
    /**
   * Recursively build breadcrumb according to activated route.
   * @param route
   * @param url
   * @param breadcrumbs
   */


    ngOnDestroy(): void {
        // tslint:disable-next-line: deprecation
        this.mobileQuery.removeListener(this._mobileQueryListener);
        this.autoLogoutSubscription.unsubscribe();
        this.myObserver.unsubscribe();
        console.log("destroy")
    }

    defineActiveMenuIconFromActiveRoute() {
        this.activeRoute = {
            users: this.router.url.startsWith('/home/users'),
            settings: this.router.url.startsWith('/home/settings'),
            settingsTypeApp: this.router.url.startsWith('/home/settings/typesApprentissages'),
            settingsCours: this.router.url.startsWith('/home/settings/cours'),
            settingsCentres: this.router.url.startsWith('/home/settings/centres'),
            settingsAnneesScolaires: this.router.url.startsWith('/home/settings/anneesScolaires'),
            groups: this.router.url.startsWith('/home/groups'),
            calendars: this.router.url.startsWith('/home/calendars'),
            apprenants: this.router.url.startsWith('/home/apprenants')
        }
        this.buildSubMenus();
    }

    manageStoredFilters() {
        if (this.router.url.startsWith('/home/users')) {
            localStorage.removeItem("settingsFilters");
            localStorage.removeItem("groupsFilters");
            localStorage.removeItem("calendarsFilter");
            localStorage.removeItem("apprenantsFilters");
        }
        else if (this.router.url.startsWith('/home/settings')) {
            localStorage.removeItem("usersFilters");
            localStorage.removeItem("groupsFilters");
            localStorage.removeItem("calendarsFilter");
            localStorage.removeItem("apprenantsFilters");
        }
        else if (this.router.url.startsWith('/home/groups')) {
            localStorage.removeItem("usersFilters");
            localStorage.removeItem("settingsFilters");
            localStorage.removeItem("calendarsFilter");
            localStorage.removeItem("apprenantsFilters");
        }
        else if (this.router.url.startsWith('/home/calendars')) {
            localStorage.removeItem("usersFilters");
            localStorage.removeItem("settingsFilters");
            localStorage.removeItem("groupsFilters");
            localStorage.removeItem("apprenantsFilters");
        }
        else if (this.router.url.startsWith('/home/apprenants')) {
            localStorage.removeItem("usersFilters");
            localStorage.removeItem("settingsFilters");
            localStorage.removeItem("groupsFilters");
            localStorage.removeItem("calendarsFilter");
        }
        else {
            localStorage.removeItem("usersFilters");
            localStorage.removeItem("settingsFilters");
            localStorage.removeItem("groupsFilters");
            localStorage.removeItem("calendarsFilter");
            localStorage.removeItem("apprenantsFilters");
        }
    }

    logout() {
        this.authService.logout(false);
        this.router.navigate(['auth/login']);

    }

    openSettingsMenu(event: MouseEvent) {
        if (this.getSubMenusLengths().settings > 0) {
            event.preventDefault();
            this.isSettingsMenuEntered = false;
            this.isSettingsIconhovered = true;

            if (this.timedOutCloser) {
                clearTimeout(this.timedOutCloser);
            }

            this.settingsMenu = true;
            this.contextMenuPosition.x = (document.getElementById('openingSettingsMenuIcon').getClientRects()[0].left - 18) + 'px';
            this.contextMenuPosition.y = (document.getElementById('openingSettingsMenuIcon').getClientRects()[0].top + (32 * this.getSubMenusLengths().settings) + 8) + 'px';
            let item = {

            }
            this.settingsMenuBtn.menuData = { 'item': item };
            this.settingsMenuBtn.menu.focusFirstItem('mouse');
            this.settingsMenuBtn.openMenu();
        }

    }

    closeSettingsMenu(event: MouseEvent) {
        event.preventDefault();
        this.isSettingsIconhovered = false;
        this.timedOutCloser = setTimeout(() => {
            if (!this.isSettingsMenuEntered) {
                this.settingsMenu = false;
                this.settingsMenuBtn.closeMenu();
            }
        }, 100);
    }

    settingsMenuLeaved() {
        setTimeout(() => {
            if (!this.isSettingsIconhovered) {
                this.settingsMenu = false;
                this.settingsMenuBtn.closeMenu();
            }
        }, 100);
    }

    settingsMenuEntered() {
        this.isSettingsMenuEntered = true;
        this.settingsMenu = true;
    }

    qualifyNotificationType(type:string){
        if(type.endsWith("_APPRENANT") || type.endsWith("_APPRENANT_CENTRE"))
            return "MANAGE_APPRENANT_NOTIFICATION";
        else if(type.endsWith("_TYPE_APPRENTISSAGE"))
            return "MANAGE_LEARNING_TYPE_NOTIFICATION";
        else if(type.endsWith("_CENTRE"))
            return "MANAGE_CENTER_NOTIFICATION";
        else if(type.endsWith("_APPRENTISSAGE"))
            return "MANAGE_APPRENTISSAGE_NOTIFICATION";
        else if(type.endsWith("_ENSEIGNANT"))
            return "MANAGE_USER_NOTIFICATION";
        else if(type.endsWith("_EVENEMENT") || type.endsWith("_GROUPE") )
            return "MANAGE_GROUP_NOTIFICATION";
    }

    addNotificationToList(obj,type){
        type = this.qualifyNotificationType(type);
        for(let element of this.notificationsList){
            if(element["type"] == type){
                element["notifs"].push(obj);
                return;
            }
        }
        this.notificationsList.push({
                type:type,
                notifs:[obj]
            });
    }

    getNotifications() {
        this.layoutService.getNotifications().subscribe(
            (data: any) => {
                let notificationsList = data;
                this.notificationNumber = data.length;
                this.notificationsList = [];
                notificationsList.forEach(notif => {
                    let obj = {
                        msg: this.getNotificationMsg(notif),
                        link: notif.urlvalidation
                    }
                    this.addNotificationToList(obj,notif.type);
                });
            },
            err => {
                console.log("err get notif", err);
            }
        )
    }

    getNotificationMsg(notif) {
        switch (notif.type) {
            case "DEMANDE_CREATION_CENTRE": return this.translate.instant("NOTIFICATIONS.DEMANDE_CREATION_CENTRE", { nom: `"${notif.value}"`, region: `"${notif.region}"` });
            case "DEMANDE_ANNULATION_EVENEMENT": return this.translate.instant("NOTIFICATIONS.DEMANDE_ANNULATION_EVENEMENT", { nom: `"${notif.value}"`, demandeur: `"${notif.demandeur}"` });
            case "DEMANDE_CREATION_EVENEMENT": return this.translate.instant("NOTIFICATIONS.DEMANDE_CREATION_EVENEMENT", { nom: `"${notif.value}"`, demandeur: `"${notif.demandeur}"` });
            case "DEMANDE_ANNULATION_GROUPE": return this.translate.instant("NOTIFICATIONS.DEMANDE_ANNULATION_GROUPE", { nom: `"${notif.value}"`, demandeur: `"${notif.demandeur}"` });
            case "DEMANDE_CREATION_GROUPE": return this.translate.instant("NOTIFICATIONS.DEMANDE_CREATION_GROUPE", { nom: `"${notif.value}"`, demandeur: `"${notif.demandeur}"` });
            case "DEMANDE_MODIF_GROUPE": return this.translate.instant("NOTIFICATIONS.DEMANDE_MODIF_GROUPE", { nom: `"${notif.value}"`, demandeur: `"${notif.demandeur}"` });
            default: return this.translate.instant("NOTIFICATIONS." + notif.type, { nom: `"${notif.value}"` });
        }
    }

    notificationRedirection(link) {
       window.location.href = link;

    }

    resetPosition() {
        let myDiv = document.getElementById("nav-bar-main");
        myDiv.scrollTop = 0;
    }
}
